export enum OnlineDetailsStepActions {
  INITIALIZE = 'initialize',
  RESET = 'reset',
  SET_DESCRIPTION = 'set-description',
  SET_IMAGE_URL = 'set-image-url',
  SET_ONLINE_NAME = 'set-online-name',
  SET_RANK = 'set-rank',
  SET_VISITED = 'set-visited',
}

type InitializeAction = {
  payload: OnlineDetailsStepState;
  type: OnlineDetailsStepActions.INITIALIZE;
};

type SetDescriptionAction = {
  payload: string;
  type: OnlineDetailsStepActions.SET_DESCRIPTION;
};

type SetImageUrlAction = {
  payload: string | undefined;
  type: OnlineDetailsStepActions.SET_IMAGE_URL;
};

type SetOnlineNameAction = {
  payload: string;
  type: OnlineDetailsStepActions.SET_ONLINE_NAME;
};

type SetRankAction = {
  payload: number | '';
  type: OnlineDetailsStepActions.SET_RANK;
};

type SetVisitedAction = {
  payload: { defaultOnlineName: string };
  type: OnlineDetailsStepActions.SET_VISITED;
};

type ResetAction = {
  type: OnlineDetailsStepActions.RESET;
};

export type OnlineDetailsStepAction =
  | InitializeAction
  | ResetAction
  | SetDescriptionAction
  | SetImageUrlAction
  | SetOnlineNameAction
  | SetRankAction
  | SetVisitedAction;

export type OnlineDetailsStepState = {
  description: string;
  displayId?: number | null;
  imageUrl: string | undefined;
  onlineName: string;
  rank: number | '';
  visited: boolean;
};

export const onlineDetailsStepDefaultState: OnlineDetailsStepState = {
  description: '',
  imageUrl: undefined,
  onlineName: '',
  rank: '',
  visited: false,
  displayId: null,
};

export function onlineDetailsStepReducer(state: OnlineDetailsStepState, action: OnlineDetailsStepAction) {
  switch (action.type) {
    case OnlineDetailsStepActions.INITIALIZE:
      return {
        ...action.payload,
      };
    case OnlineDetailsStepActions.RESET:
      return {
        ...onlineDetailsStepDefaultState,
      };
    case OnlineDetailsStepActions.SET_DESCRIPTION:
      return {
        ...state,
        description: action.payload,
      };
    case OnlineDetailsStepActions.SET_IMAGE_URL:
      return {
        ...state,
        imageUrl: action.payload,
      };
    case OnlineDetailsStepActions.SET_RANK:
      return {
        ...state,
        rank: action.payload,
      };
    case OnlineDetailsStepActions.SET_ONLINE_NAME:
      return {
        ...state,
        onlineName: action.payload,
      };
    case OnlineDetailsStepActions.SET_VISITED:
      return {
        ...state,
        onlineName: action.payload.defaultOnlineName,
        visited: true,
      };
    default:
      return state;
  }
}
